//课中活动讨论
export const SHOW_LIST = 'show_list'
export const SHOW_INFO = 'show_info'


// WEBPACK FOOTER //
// ./src/store/kzActivity/show/type.js